import React, { useContext } from 'react';
import { useUser } from '../../context/UserContext';

// Import components for different user roles
import IssuerList from '../IssuerList/IssuerList'; // For admin/internal users
import Issuers from '../LandingPages/Issuers'; // For external users

const ConditionalIssuerRoute = () => {
  const { userData } = useUser();

  // Check if user is external (only EXTERNAL_USER role)
  const isExternalUser = () => {
    if (!userData || !userData.roles || userData.roles.length === 0) {
      return true; // Default to external if no roles
    }
    
    // Check if user has EXTERNAL_USER role
    return userData.roles.includes('EXTERNAL_USER');
  };

  // Render appropriate component based on user role
  if (isExternalUser()) {
    console.log('Rendering external Issuers component for user:', userData?.username);
    return <Issuers skipLayout={true} />;
  } else {
    console.log('Rendering internal IssuerList component for user:', userData?.username);
    return <IssuerList />;
  }
};

export default ConditionalIssuerRoute;
